import React from 'react';
import { useSelector} from 'react-redux';
import SidebarItem from './SidebarItemSociete';
import data from '../Data/dataSociete.json';

const SidebarSociete = ({ hide,logout }) => {
    
  const societe = useSelector((state) => state.societe);
    return (
        <div className='sidebar d-flex flex-column h-100 justify-content-between'>
            <div className='bloc_sidebar'>
                <div className='bg-white pt-2'>
                    <div className='d-flex justify-content-end close_button'>
                        <i className='fa fa-close' onClick={() => hide()}></i>
                    </div>
                    <h1 className='text-center'>Administrateurs</h1>
                    <h2 className='text-center'>{societe.nom}</h2>
                    <h2 className='text-center mb-5'>{societe.prenom}</h2>
                </div>
                {/* <div style={{marginTop:'10px'}}> */}
                {data.map((item, index) => <SidebarItem key={index} item={item} />)}
                {/* </div> */}
            </div>
            <div className='bloc_deconnection'>
                <div className='d-flex justify-content-center'>
                    <button className='btn' onClick={()=>logout()}><i className='fa fa-power-off'></i>Je me déconnecte</button>
                </div>
            </div>
        </div>
    )
}

export default SidebarSociete